export default "__VITE_ASSET__DOpLXhrm__"